/*
  PDP ingredient popup (2026-10-04).
  Markup comes from snippets/ingredient-links.liquid: .ingredient-trigger links
  in the Key Ingredients accordion, one <template id="ingredient-{handle}"> per
  ingredient, and a single <dialog class="ingredient-modal">. No dependencies.
*/
(function () {
  'use strict';

  var dialog = document.querySelector('dialog.ingredient-modal');
  if (!dialog) return;

  // Browsers without <dialog> (iOS before 15.4): the triggers are real links,
  // so leave them alone and they open the ingredient page.
  if (typeof dialog.showModal !== 'function') return;

  // The dialog is rendered inside the accordion; move it to <body> so a closed
  // or collapsing accordion panel can never hide it.
  document.body.appendChild(dialog);

  var content = dialog.querySelector('[data-ingredient-content]');
  var sheet = dialog.querySelector('.ingredient-modal__sheet');
  var closeBtn = dialog.querySelector('.ingredient-modal__close');
  var product = dialog.getAttribute('data-product') || '';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var lastTrigger = null;
  var current = '';
  var closing = false;
  // Every open/close bumps this, so a close timer that is still pending from an
  // earlier close cannot shut a popup that was reopened in the meantime.
  var seq = 0;

  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
    // GA4 (the Google & YouTube app's tag), same pattern as the skin quiz.
    try { if (typeof window.gtag === 'function') window.gtag('event', name, Object.assign({ send_to: 'G-386HSM6S18' }, data)); } catch (e) {}
  }

  // Scroll lock that keeps the reader's place. The theme sets html and body to
  // height: 100%, so plain overflow: hidden snapped the page to the top behind
  // the popup, and iOS Safari left it there after closing (2026-10-05). Pin the
  // body at its current offset instead, then put the scroll position back.
  // Pinning the body un-sticks the sticky PDP gallery (it drops back to its
  // place at the top of the column), so hold it where it was with a transform
  // while the popup is open (2026-10-08).
  var savedY = 0;
  var bodyStyle = document.body.style;
  var held = [];
  // While the body is pinned the page reports scrollY 0, which the theme's
  // header reads as "back at the top" and fades the header in behind the popup.
  // Swallow scroll events until the position is restored (window capture
  // listeners run before the theme's own window listeners).
  var muted = false;
  window.addEventListener('scroll', function (e) { if (muted) e.stopImmediatePropagation(); }, true);
  function lockScroll() {
    savedY = window.scrollY || window.pageYOffset || 0;
    var bw = document.body.getBoundingClientRect().width;
    var sticky = document.querySelectorAll('.pdp-gallery-col');
    var before = [];
    for (var i = 0; i < sticky.length; i++) before.push(sticky[i].getBoundingClientRect().top);
    muted = true;
    bodyStyle.position = 'fixed';
    bodyStyle.top = (-savedY) + 'px';
    bodyStyle.left = '0';
    // Keep the exact width the page had, so nothing shifts sideways whether a
    // scrollbar disappears or the lock's scrollbar-gutter reserves one.
    bodyStyle.width = bw + 'px';
    // The theme's body is height: 100%, and the lock class gives it overflow:
    // hidden, so a pinned body clipped the page to one window height starting
    // at the top of the page: scrolled down, the gallery and copy were cut off
    // behind the popup. Let it keep its full height; <html> still blocks scroll.
    bodyStyle.height = 'auto';
    bodyStyle.overflow = 'visible';
    document.documentElement.classList.add('ingredient-modal-lock');
    held = [];
    for (var j = 0; j < sticky.length; j++) {
      var d = before[j] - sticky[j].getBoundingClientRect().top;
      if (Math.abs(d) > 0.5) { sticky[j].style.transform = 'translateY(' + d + 'px)'; held.push(sticky[j]); }
    }
  }
  function unlockScroll() {
    document.documentElement.classList.remove('ingredient-modal-lock');
    bodyStyle.position = '';
    bodyStyle.top = '';
    bodyStyle.left = '';
    bodyStyle.width = '';
    bodyStyle.height = '';
    bodyStyle.overflow = '';
    for (var i = 0; i < held.length; i++) held[i].style.transform = '';
    held = [];
    // 'instant' so a site-wide smooth scroll can't animate the jump back.
    try { window.scrollTo({ top: savedY, left: 0, behavior: 'instant' }); }
    catch (e) { window.scrollTo(0, savedY); }
    // Scroll events are dispatched on the next frame; unmute after that.
    requestAnimationFrame(function () { requestAnimationFrame(function () { muted = false; }); });
  }

  function open(trigger) {
    var handle = trigger.getAttribute('data-ingredient');
    var tpl = document.getElementById('ingredient-' + handle);
    if (!tpl) return;
    content.textContent = '';
    content.appendChild(tpl.content.cloneNode(true));
    current = handle;
    lastTrigger = trigger;
    seq++;
    closing = false;
    cleaned = false;
    dialog.classList.remove('is-closing');
    dialog.style.transform = '';
    sheet.scrollTop = 0;
    lockScroll();
    dialog.showModal();
    // Focus the close button rather than the first link, so the story link is
    // not pre-selected and Enter does not navigate by accident.
    closeBtn.focus();
    track('ingredient_popup_open', { ingredient: handle, product: product });
  }

  // Unlock the page and hand focus back. Called straight after close() and
  // again from the dialog's own 'close' event (which also covers closes the
  // browser forces, e.g. a second Esc); the flag makes it run once per open.
  var cleaned = true;
  function cleanup() {
    if (cleaned || dialog.open) return;
    cleaned = true;
    closing = false;
    dialog.classList.remove('is-closing');
    dialog.style.transform = '';
    unlockScroll();
    // preventScroll: the page is already back where the reader left it.
    if (lastTrigger && document.contains(lastTrigger)) {
      try { lastTrigger.focus({ preventScroll: true }); } catch (e) { lastTrigger.focus(); }
    }
  }

  function finishClose() {
    dialog.classList.remove('is-closing');
    if (dialog.open) dialog.close();
    cleanup();
  }

  function close() {
    if (!dialog.open || closing) return;
    if (reduceMotion.matches) { finishClose(); return; }
    closing = true;
    dialog.classList.add('is-closing');
    var mine = ++seq;
    var done = false;
    var end = function () { if (done) return; done = true; if (mine === seq) finishClose(); };
    dialog.addEventListener('animationend', end, { once: true });
    setTimeout(end, 300); // fallback if no animation runs
  }

  dialog.addEventListener('close', cleanup);

  // Esc: run our close so the exit animation plays.
  dialog.addEventListener('cancel', function (e) { e.preventDefault(); close(); });

  closeBtn.addEventListener('click', close);

  // Backdrop click: the sheet fills the dialog box, so a click whose target is
  // the dialog itself landed on the backdrop.
  dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });

  // Triggers (event delegation, works for any number of accordions).
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.ingredient-trigger');
    if (!t || e.defaultPrevented) return;
    // Cmd/Ctrl/Shift/middle click keep normal link behaviour (new tab/window).
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    // No popup content for this ingredient: let the link open the article.
    if (!document.getElementById('ingredient-' + t.getAttribute('data-ingredient'))) return;
    e.preventDefault();
    open(t);
  });

  dialog.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-ingredient-link]');
    if (link) track('ingredient_popup_click_through', { ingredient: current, product: product });
  });

  // Mobile: swipe the sheet down to close (only when scrolled to its top).
  var startY = null;
  var dy = 0;
  sheet.addEventListener('touchstart', function (e) {
    if (closing || window.innerWidth >= 750 || sheet.scrollTop > 0 || e.touches.length !== 1) { startY = null; return; }
    startY = e.touches[0].clientY;
    dy = 0;
    dialog.style.transition = 'none';
  }, { passive: true });
  sheet.addEventListener('touchmove', function (e) {
    if (startY === null) return;
    dy = Math.max(0, e.touches[0].clientY - startY);
    dialog.style.transform = dy ? 'translateY(' + dy + 'px)' : '';
  }, { passive: true });
  sheet.addEventListener('touchend', function () {
    if (startY === null) return;
    startY = null;
    var shouldClose = dy > 90;
    dy = 0;
    if (shouldClose && reduceMotion.matches) { dialog.style.transition = ''; dialog.style.transform = ''; finishClose(); return; }
    dialog.style.transition = 'transform .2s ease';
    dialog.style.transform = shouldClose ? 'translateY(100%)' : '';
    var mine = shouldClose ? ++seq : seq;
    setTimeout(function () {
      if (shouldClose && mine !== seq) return;
      dialog.style.transition = '';
      if (shouldClose) { finishClose(); dialog.style.transform = ''; }
    }, 210);
  });
})();
